import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import ParticipantItem from './ParticipantItem'
import { Participant as IParticipant } from 'twilio-video'
import { Button, Tooltip } from 'antd'
import { faCompress, faExpand } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type TProps = {
	participants: IParticipant[]
	dominantSpeaker: string
	localParticipantSid: string
}

const Participants: FunctionComponent<TProps> = ({ participants, dominantSpeaker, localParticipantSid }) => {
	const [participantSize, setParticipantSize] = useState<{ height: string; width: string }>({
		height: '100%',
		width: '100%',
	})
	const containerRef = useRef<HTMLDivElement>()
	const [screenMode, setScreenMode] = useState<{ id: string; isFullScreen: boolean }>({ id: null, isFullScreen: false })

	const calculateSize = () => {
		if (!containerRef.current?.clientHeight || !containerRef.current?.clientWidth) {
			return
		}
		const height = `${Math.ceil(containerRef.current.clientHeight / Math.ceil(participants.length / 2) - 2)}px`
		const width = participants.length > 1 ? `${containerRef.current.clientWidth / 2}px` : '100%'
		setParticipantSize({ height: height, width: width })
	}

	useEffect(() => {
		calculateSize()
	}, [participants.length])

	useEffect(() => {
		window.addEventListener('resize', calculateSize)
		return () => {
			window.removeEventListener('resize', calculateSize)
		}
	})

	const ScreenModeIcon = screenMode.isFullScreen ? (
		<FontAwesomeIcon color="white" icon={faCompress} />
	) : (
		<FontAwesomeIcon color="white" icon={faExpand} />
	)

	return (
		<div className="room-participants" ref={containerRef}>
			{participants.length > 0 && (
				<>
					{participants.map((participant) => (
						<div
							className={`${
								screenMode.isFullScreen && screenMode.id === participant.sid ? 'full-screen' : ''
							} room-participant room-participant-pointer`}
							key={participant.sid}
						>
							<ParticipantItem
								participant={participant}
								style={{ height: participantSize.height, width: participantSize.width }}
								mainParticipant={false}
								localParticipant={participant.sid === localParticipantSid}
								dominantSpeaker={participant.sid === dominantSpeaker}
							/>
							<div style={{ position: 'absolute', bottom: 0, right: 0 }}>
								<Tooltip placement="topLeft" title={`${screenMode.isFullScreen ? 'Collapse' : 'Expand'}`}>
									<Button
										style={{ padding: '5px 10px', fontSize: '20px' }}
										type="link"
										onClick={() =>
											setScreenMode((prev) => ({
												isFullScreen: !prev.isFullScreen,
												id: participant.sid,
											}))
										}
									>
										{ScreenModeIcon}
									</Button>
								</Tooltip>
							</div>
						</div>
					))}
				</>
			)}
		</div>
	)
}

export default Participants
